export const ASAP_API_SERVICE_NAME = 'asapApi';

export enum SortDirection {
    Ascending = 'ASC',
    Descending = 'DESC'
}
